export default "__VITE_ASSET__d7cyQG59__"